import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { CityListFragmentDoc } from '../../CityList/__generated__/CityList.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCityRootByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetCityRootByIdQuery = { __typename?: 'Query', getCityById?: { __typename?: 'City', id: string, name: string, latin: string, active?: boolean | null } | null };


export const GetCityRootByIdDocument = gql`
    query getCityRootById($id: ID!) {
  getCityById(id: $id) {
    ...CityList
  }
}
    ${CityListFragmentDoc}`;

/**
 * __useGetCityRootByIdQuery__
 *
 * To run a query within a React component, call `useGetCityRootByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityRootByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityRootByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCityRootByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCityRootByIdQuery, GetCityRootByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityRootByIdQuery, GetCityRootByIdQueryVariables>(GetCityRootByIdDocument, options);
      }
export function useGetCityRootByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityRootByIdQuery, GetCityRootByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityRootByIdQuery, GetCityRootByIdQueryVariables>(GetCityRootByIdDocument, options);
        }
export type GetCityRootByIdQueryHookResult = ReturnType<typeof useGetCityRootByIdQuery>;
export type GetCityRootByIdLazyQueryHookResult = ReturnType<typeof useGetCityRootByIdLazyQuery>;
export type GetCityRootByIdQueryResult = Apollo.QueryResult<GetCityRootByIdQuery, GetCityRootByIdQueryVariables>;